<template>
    <div :id="id" :class="['dropdown', isExpanded ? 'expanded' : '']">
      <select v-model="selected"
              @focusin="toggleExpand"
              @focusout="toggleExpand"
              @change="$emit('input', selected)"
              :disabled="disabled">
        <option v-show="false" selected :value="null">{{placeholder}}</option>
        <option value="1"> AMERICAN EXPRESS</option>
        <option value="2"> DISCOVER </option>
        <option value="3"> MASTERCARD </option>
        <option value="4"> VISA </option>
      </select>
    </div>
</template>

<script>
export default {
  name: 'Dropdown',
  props: {
    id: String,
    disabled: Boolean,
    placeholder: {
      type: String,
      default: 'Select...'
    }
  },
  data () {
    return {
      selected: null,
      isExpanded : false
    }
  },
  mounted() {
    this.$emit('input', this.selected)
  },
  methods: {
    toggleExpand () {
      this.isExpanded = !this.isExpanded;
    }
  }
}
</script>

<style scoped>
  /* Reset Select */
  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    -ms-appearance: none;
    appearance: none;
    outline: 0;
    box-shadow: none;
    border: 0 !important;
    background: white;
    background-image: none;
  }

  /* Remove IE arrow */
  select::-ms-expand {
    display: none;
  }

  /* Custom Select */
  select {
    height: 100%;
    width: 100%;
    flex: 1;
    padding-left: 25px;
    color: black;
    cursor: pointer;
  }

  select:disabled {
    color: grey;
    cursor: not-allowed;
  }

  .dropdown {
    position: relative;
    background: white;
    overflow: hidden;
    border-radius: 7px;
  }

  .dropdown {
    width: 100%;
    position: relative;
    min-height: 2em;
    overflow: hidden;
    cursor: pointer;
    text-align: left;
    white-space: nowrap;
    color: #444;
    outline: none;
    transition: 0.3s all ease-in-out;
  }

  .dropdown input:checked + label {
    display: block;
    border-top: none;
    position: absolute;
    top: 0;
    width: 100%;
  }
  .dropdown input:checked + label:nth-child(2) {
    margin-top: 0;
    position: relative;
  }
  .dropdown::after {
    content: "";
    position: absolute;
    right: 1em;
    top: 1.4em;
    border: 0.3em solid #8cb6c0;
    border-color: #8cb6c0 transparent transparent transparent;
    transition: .4s all ease-in-out;
  }
  .dropdown.expanded {
    border: 0.06em solid #3694d7;
    background: white;
    border-radius: .25em;
    padding: 0;
    box-shadow: rgba(0, 0, 0, 0.1) 3px 3px 5px 0px;
    max-height: 15em;
  }
  .dropdown.expanded label {
    border-top: .06em solid #d9d9d9;
  }
  .dropdown.expanded::after {
    transform: rotate(-180deg);
    top: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/CreditCardSelect.vue